import { SaveRecordAction } from '@aibees/elephant/hooks';
import { useEnrichPersonSaveRecord } from '@aibees/elephant/hooks/people/use-enrich-person-save-record';
import { useSaveRecordEnrichableCount } from '@aibees/elephant/hooks/people/use-save-record-enrichable-count';
import { CreditUsageType } from '@aibees/shared/definition';
import { useCreditUsageItem } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { InfoItem } from '../enrich-dialog';
import * as Styled from './styles';
import * as SX from './sx';
import type { EnrichPhoneNumberDialogProps as Props } from './types';

export const EnrichPhoneNumberDialog = memo(
  ({ className, onClose, open, table }: Props) => {
    const { enrichable, isLoading: countLoading } =
      useSaveRecordEnrichableCount(
        SaveRecordAction.CONTACT_REVEAL_PHONE_CACHED,
        open ? table : undefined
      );

    const { credit } = useCreditUsageItem(
      CreditUsageType.CONTACT_PHONE_FINDING
    );

    const { handleEnrich, isLoading } = useEnrichPersonSaveRecord(
      SaveRecordAction.CONTACT_REVEAL_PHONE_CACHED,
      onClose,
      table,
      enrichable
    );

    const informations: InfoItem[] = [
      {
        count: enrichable,
        label: 'records require enrichment',
      },
    ];

    return (
      <Styled.Wrapper
        className={classnames('EnrichPhoneNumberDialog', className)}
        sx={SX.root}
        open={open}
        onClose={onClose}
        icon="phone"
        title="Enrich Mobile Phone Numbers"
        informations={informations}
        cost={credit}
        onSubmit={handleEnrich}
        enrichLoading={isLoading}
        countLoading={countLoading}
        disableEnrich={!enrichable || enrichable === 0}
        unEnrichableHelperText="The selected contacts phone numbers are already enriched and don't need enrichment."
        recordsCount={table?.selection.included.length || 0}
      />
    );
  }
);

EnrichPhoneNumberDialog.displayName = 'EnrichPhoneNumberDialog';
